import { login, logout, getInfo } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'
import Cookies from 'js-cookie'

const user = {
  state: {
    token: getToken(),
    name: '',
    avatar: '',
    roles: [],
    isLogin: false
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    }
  },

  actions: {
    // 登录  0626 目前登录接口还不行，模拟后台调用并设置token
    Login ({ commit }, userInfo) {
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        login({ username, password: userInfo.password }).then(response => {
          const data = response
          if (data.code == 200 && data.success) {
            setToken(data.result.token) // 目前后台并没返回token 前端搞个假的
            commit('SET_TOKEN', data.result.token)
            resolve()
          }
          if(response && response.code==200){
            setToken(response.data.token) // 目前后台并没返回token 前端搞个假的
            commit('SET_TOKEN', response.data.token)
            resolve()
          }
        }).catch(error => {
          reject(error)
        })
        // setTimeout(() => {
        //   if (username == 'admin' && userInfo.password == 'admin') {
        //     setToken('14782iuayriyq91734984')
        //     commit('SET_TOKEN', '14782iuayriyq91734984')
        //     resolve()
        //   } else {
        //     alert('密码错误')
        //   }
        // }, 0)
      })
    },

    // 获取用户信息
    GetInfo ({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo().then(response => {
          const data = response.data
          if (data.roles && data.roles.length > 0) { // 验证返回的roles是否是一个非空数组
            commit('SET_ROLES', data.roles)
          } else {
            reject('getInfo: roles must be a non-null array !')
          }
          commit('SET_NAME', data.username) // 用户名
          commit('SET_AVATAR', data.icon) // 头像
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    LogOut ({ commit, state }) {
      return new Promise((resolve, reject) => {
        // logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          removeToken()
          resolve()
        // }).catch(error => {
        //   reject(error)
        // })
      })
    },

    // 前端 登出
    FedLogOut ({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js